import React, {useRef,} from "react";
import { useRive, Layout, Fit, Alignment, useStateMachineInput } from "@rive-app/react-canvas";

export const Sam = ({ animation }) => {
    const { rive, RiveComponent } = useRive({
        // Load a local riv `clean_the_car.riv` or upload your own!
        src: "sam.riv",
        // Be sure to specify the correct state machine (or animation) name
        stateMachines: "State Machine 1",
        // This is optional.Provides additional layout control.
        layout: new Layout({
            fit: Fit.FitHeight, // Change to: rive.Fit.Contain, or Cover
            alignment: Alignment.Center,
        }),
        autoplay: true,
    });
    
    const state = useStateMachineInput(rive, "State Machine 1", "state");
    const blink = useStateMachineInput(rive, "State Machine 1", "blink");
    

    const timeout = useRef(null);
    const blinkTimeout = ()=>{
        if(!timeout.current){
            timeout.current = setTimeout(() => {
                blink.fire();
                timeout.current = null;
                blinkTimeout();
            }, (Math.floor(Math.random() * 5000) + 2000));
        }
    }

    React.useEffect(() => {
        if (state) {
            state.value = animation;
            
            if(blink){
                blink.fire();
                if(!timeout.current){
                    blinkTimeout();
                }
            }

            
        }
    }, [animation]);



    return <RiveComponent/>
};